import axios from 'axios';
import { apiTransitionAgents, setAgentsValue } from '../../../actions/biasharaFlexi/agentModal';
import { setExpiredAuth } from '../../../actions/biasharaFlexi/quote';
 
export const getIntermeiaryAgent = (store, next, action) => {
    (async() => {
        store.dispatch(apiTransitionAgents.pending());
        try {
            const state = store.getState();
            const token = state?.biasharaFlexi?.auth?.loginData?.accessToken
            const intermediaryType = state?.biasharaFlexi?.agent?.form?.intermediaryType?.value;
            const resp = await calculate(token, intermediaryType);
            store.dispatch(setAgentsValue(resp.data));
            store.dispatch(apiTransitionAgents.success());
        } catch (error) {
            if (error?.response?.data?.status === 401 || error?.response?.data?.status === 403) {
                store.dispatch(setExpiredAuth(true));
            }
            store.dispatch(apiTransitionAgents.failure());
        }
    })();
    return next(action);
}
 
const calculate = async (token, intermediaryType) => {
    try {
        const url = `/om-api/biashara-flexi/agents/kenya`;
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                intermediary_type: intermediaryType
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};